<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div id="topo" class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Gerenciamento das Declarações Eletrônicas de Substituição
                  Tributária para o Município.</span>
                <br />
                <span class="navigation">Substituição Tributária > Declaração</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <consulta-nota-nacional />
          <label style="font-weight: bold; font-size: 12px">Competência:</label>
          <div class="row">
            <div class="col-md-4 col-lg-2 mb-3">
              <InputText v-model="competencia" disabled />
            </div>
            <div>
              <Button @click="alterarCompetencia()" label="Alterar" type="button" class="p-button-primary mr-2"
                icon="pi pi-search" :disabled="loading" />
            </div>
            <div class="col-md-4 col-lg-2 mb-3">
              <Button @click="showNotaDam()" alt="Pesquisar Por Nfse" label="Pesquisar Por Nfse" type="button"
                class="p-button-primary mr-2 p-button-success" icon="pi pi-search" :disabled="loading" />
              <label style="font-size: 12px" v-if="this.numeroNfsePesquisa">Filtro Nfse Número:
                {{ this.numeroNfsePesquisa }}</label>
              <label style="font-size: 12px" v-if="this.filtro">Filtro CPF/CNPJ/Nome Prestador:
                {{ this.filtro }}</label>
            </div>
            <div class="col-md-4 col-lg-2 mb-3" v-if="false">
              <router-link to="/importacaoAceite">
                <Button type="button" icon="pi pi-upload" label="Importar notas fiscais"
                  title="Importar notas fiscais" />
              </router-link>
            </div>
          </div>

          <hr />

          <template v-if="!displayRetificar">
            <div class="pl-3 pr-3">
              <div class="pb-3" v-if="isPossuiTaxasDebito">
                <span style="font-weight: bold; color:red">
                  Uma ou mais declarações foram encerradas com débito para essa competência. Realize o pagamento da Taxa gerada.
                </span>
              </div>
            
              <Panel :toggleable="false" header="Taxa" v-if="isPossuiTaxas">
                <div v-for="taxa in listTaxas" v-bind:key="taxa.id">
                  <hr v-if="taxa.id != listTaxas[0].id" />
                  <div class="row">
                    <div class="col-sm-2 d-flex align-items-center" v-if="isPossuiTaxasDebito">
                      <Button type="button" title="Imprimir Taxa" :label="!admin ? 'Imprimir' : ''" class="p-button-primary" icon="pi pi-print"
                        style="margin-right: 0.5em" @click="imprimirBoletoTaxa(taxa)" :disabled="loading"/>
                      <Button type="button" title="Cancelar Taxa" class="p-button-danger" icon="pi pi-times"
                        style="margin-right: 0.5em" @click="exibirCancelarTaxa(taxa)" :disabled="loading" v-if="admin && taxa.idBolDebito === 'S'"/>
                    </div>
                    <div class="col">
                      <div class="row">
                        <div class="col-sm mt-1 mb-1">
                          <b>Vencimento:</b>
                          {{taxa.vencimentoFormatado}}
                        </div>
                        <div class="col-sm mt-1 mb-1">
                          <b>Pagamento:</b>
                          {{taxa.pagamentoFormatado}}
                        </div>
                        <div class="col-sm mt-1 mb-1">
                          <b>Valor:</b>
                          {{taxa.valorFormatado}}
                        </div>
                        <div class="col-sm mt-1 mb-1">
                          <b>Pago:</b>
                          {{taxa.valorPagoFormatado}}
                        </div>
                      </div>                 
                    </div>  
                  </div>  
                </div>
              </Panel>
            </div> 
            <hr v-if="isPossuiTaxas"/>

            <div class="row pr-3 pl-3">
              <h4 class="panel-title">
                <span class="title">Declarações Geradas na Competência.</span>
              </h4>
              <DataTable :value="listDeclaracao" :paginator="true" :rows="10" class="p-datatable-responsive" :key="0"
                :autoLayout="true" style="min-width: 100%" :rowClass="rowClass" ref="dt1" :filters="filtersModel">
                <Column headerStyle="width: 1%">
                  <template #body="slotProps">
                    <div class="dropdown">
                      <Button class="btn btn-primary" type="button" id="dropdownMenuButton" icon="pi pi-angle-down"
                        data-toggle="dropdown" title="Opções" aria-haspopup="true" aria-expanded="false"></Button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="exportarExcel(slotProps.data.id)">
                          <span class="pi pi-file-excel mr-2"></span>Exportação
                          Declaração
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="impressaoDeclaracao(slotProps.data.id)">
                          <span class="pi pi-print mr-2"></span>Impressão
                          Declaração
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="impressaoProtocolo(slotProps.data.id)" v-if="apresentacao">
                          <span class="pi pi-print mr-2"></span>Impressão
                          Protocolo
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading" @click="
                          impressaoBoletos(
                            slotProps.data.id,
                            slotProps.data.pago
                          )
                          " v-if="slotProps.data.dataEncerramento &&
                            !slotProps.data.dataVigenciaFinal &&
                            slotProps.data.semMovimento != 'Sim' &&
                            slotProps.data.idBolDebito === 'S'">
                          <span class="pi pi-print mr-2"></span>Impressão
                          Boleto(s)
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="encerrarDeclaracao(slotProps.data.id)" v-if="!isBloqueado && !slotProps.data.dataEncerramento &&
                            !slotProps.data.dataVigenciaFinal
                          ">
                          <span class="pi pi-pencil mr-2"></span>Encerrar
                          Declaração
                        </button>
                        <div class="dropdown-divider" v-if="!isBloqueado && !slotProps.data.dataEncerramento &&
                          !slotProps.data.dataVigenciaFinal
                        " />
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="carregarRetificacao(slotProps.data)" v-if="!isBloqueado && slotProps.data.dataEncerramento &&
                            !slotProps.data.dataVigenciaFinal &&
                            slotProps.data.pago != 'Sim'  &&
                            (slotProps.data.idBolDebito === 'S' || slotProps.data.idBolDebito === 'M')
                          ">
                          <span class="pi pi-replay mr-2"></span>{{ !isAnaliseRetificacao ? 'Retificar Declaração' : 'Cancelar Declaração' }}
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="showDiaglogAplicarCredito(slotProps.data)" v-if="!isBloqueado && slotProps.data.dataEncerramento &&
                            !slotProps.data.dataVigenciaFinal &&
                            slotProps.data.semMovimento != 'Sim' &&
                            slotProps.data.idBolDebito === 'S' && habilitarCredito">
                          <span class="pi pi-money-bill mr-2"></span>Aplicar Crédito
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="cancelarDeclaracao(slotProps.data.id)" v-if="!isBloqueado && !slotProps.data.dataEncerramento &&
                            !slotProps.data.dataVigenciaFinal 
                          ">
                          <span class="pi pi-times mr-2"></span>Cancelar
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="carregarAvulsos(slotProps.data.id)">
                          <span class="pi pi-list mr-2"></span>Lançamentos
                          Avulsos
                        </button>
                        <button class="dropdown-item" type="button"
                          v-show="!isBloqueado && slotProps.data.dataEncerramento && currentUser.usuario.idBolAdmin"
                          :disabled="loading || inativo" @click="openTransferirCalculoes(slotProps.data)">
                          <span class="pi pi-pencil mr-2"></span>Transferir Valores
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="openSuspensao(slotProps.data, 'S')" v-if="!isBloqueado && slotProps.data.dataEncerramento && currentUser.usuario.idBolAdmin &&
                            !slotProps.data.dataVigenciaFinal &&
                            slotProps.data.pago != 'Sim'  &&
                            (slotProps.data.idBolDebito === 'S' || slotProps.data.idBolDebito === 'M')
                          ">
                          <span class="pi pi-key mr-2"></span>Suspender Guia
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="openSuspensao(slotProps.data, 'C')" v-if="!isBloqueado && slotProps.data.dataEncerramento && currentUser.usuario.idBolAdmin &&
                            !slotProps.data.dataVigenciaFinal &&
                            slotProps.data.pago != 'Sim'  &&
                            (slotProps.data.situacao === 'Suspenso Processo')
                          ">
                          <span class="pi pi-lock-open mr-2"></span>Cancelar Suspenso Processo
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="imprimirNotificacao(slotProps.data.id)" v-if="slotProps.data.dataEncerramento &&
                            !slotProps.data.dataVigenciaFinal &&
                            slotProps.data.pago != 'Sim' &&
                            (slotProps.data.situacao === 'Notificado')
                          ">
                          <span class="pi pi-print mr-2" ></span>Imprimir Notificação
                        </button>
                        <button class="dropdown-item" type="button" :disabled="loading"
                          @click="imprimirAutoInfracao(slotProps.data.id)" v-if="slotProps.data.dataEncerramento &&
                            !slotProps.data.dataVigenciaFinal &&
                            slotProps.data.pago != 'Sim' &&
                            (slotProps.data.situacao === 'Auto de Infração')
                          ">
                          <span class="pi pi-print mr-2" style="padding-right: 2vw"></span>Detalhes Auto de Infração
                        </button>
                      </div>
                    </div>
                  </template>
                </Column>
                <Column headerStyle="width: 10%" field="id" header="Id" v-if="false">
                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{ slotProps.data.id }}
                    </div>
                  </template>
                </Column>
                <Column headerStyle="width: 10%" field="numero" header="Número">
                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{ slotProps.data.numero }}
                    </div>
                  </template>
                  <template #filter>
                    <InputText type="text" v-model="filtersModel['numero']" class="p-column-filter"
                      placeholder="Iniciando com" style="width: 10em" />
                  </template>
                </Column>
                <Column headerStyle="width: 15%" field="idRetificado" header="Retificado">
                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{
                        slotProps.data.numeroRetificador
                          ? "Retificado pela Declaração nº " +
                          slotProps.data.numeroRetificador
                          : "-"
                      }}
                    </div>
                  </template>
                </Column>
                <Column headerStyle="width: 3%" field="dataFormatada" header="Data">
                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{ slotProps.data.dataFormatada }}
                    </div>
                  </template>
                  <template #filter>
                    <InputText type="text" v-model="filtersModel['dataFormatada']" class="p-column-filter"
                      placeholder="Iniciando com" style="width: 5em" />
                  </template>
                </Column>
                <Column headerStyle="width: 5%" field="semMovimento" header="Sem Movimento?">
                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{ slotProps.data.semMovimento }}
                    </div>
                  </template>
                  <template #filter>
                    <InputText type="text" v-model="filtersModel['semMovimento']" class="p-column-filter"
                      placeholder="Iniciando com" style="width: 5em" />
                  </template>
                </Column>
                <Column headerStyle="width: 10%" field="situacao" header="Status">
                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{ slotProps.data.situacao }}
                    </div>
                  </template>
                  <template #filter>
                    <InputText type="text" v-model="filtersModel['situacao']" class="p-column-filter"
                      placeholder="Iniciando com" style="width: 10em" />
                  </template>
                </Column>
                <Column headerStyle="width: 5%" field="pago" header="Pago?">
                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{ slotProps.data.pago }}
                    </div>
                  </template>
                  <template #filter>
                    <InputText type="text" v-model="filtersModel['pago']" class="p-column-filter"
                      placeholder="Iniciando com" style="width: 5em" />
                  </template>
                </Column>
                <Column headerStyle="width: 5%" field="dataPagamentoFormatada" header="Data Pagamento">
                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{ slotProps.data.dataPagamentoFormatada }}
                    </div>
                  </template>
                  <template #filter>
                    <InputText type="text" v-model="filtersModel['dataPagamentoFormatada']" class="p-column-filter"
                      placeholder="Iniciando com" style="width: 5em" />
                  </template>
                </Column>
                <Column headerStyle="width: 10%" field="valor" header="Valor">
                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{ slotProps.data.valorFormatado }}
                    </div>
                  </template>
                  <template #filter>
                    <InputText type="text" v-model="filtersModel['valor']" class="p-column-filter"
                      placeholder="Iniciando com" style="width: 10em" />
                  </template>
                </Column>
                <Column headerStyle="width: 10%" field="valorPago" header="Valor Pago">
                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{ slotProps.data.valorPagoFormatado }}
                    </div>
                  </template>
                  <template #filter>
                    <InputText type="text" v-model="filtersModel['valorPago']" class="p-column-filter"
                      placeholder="Iniciando com" style="width: 10em" />
                  </template>
                </Column>
                <Column v-if="currentUser.configuracao.idBolExibirDetalhamentoDam === 'S'" headerStyle="width: 10%" field="origem" header="Origem Prestador">
                  <template #body="slotProps">
                    <div :class="lineClass(slotProps.data)">
                      {{ slotProps.data.origemFormatada }}
                    </div>
                  </template>
                  <template #filter>
                    <InputText type="text" v-model="filtersModel['origem']" class="p-column-filter"
                      placeholder="Iniciando com" style="width: 10em" />
                  </template>
                </Column>
                <template #footer>
                  <div style="text-align: right">
                    <Button icon="pi pi-external-link" label="Exportar para CSV" @click="exportCSVDt1($event)" />
                  </div>
                </template>
              </DataTable>
            </div>
          </template>
          <template v-else>
            <div class="row">
              <div class="container-fluid">
                <div class="row">
                  <Card style="width: 100%">
                    <template slot="title">Declaração de Número
                      {{ this.declaracaoSelecionada.numero }} Selecionada para
                      retificação.</template>
                    <template slot="content">
                      Data: {{ this.declaracaoSelecionada.dataFormatada }}
                      <br />
                      Sem Movimento?
                      {{ this.declaracaoSelecionada.semMovimento }}
                      <br />
                    </template>
                  </Card>
                </div>
              </div>
              <div class="container-fluid">
                <div class="row">
                  <h4 class="panel-title" style="margin-top: 1px">
                    <span class="title">Notas Fiscais/DAPS relacionadas a Declaração.</span>
                  </h4>
                </div>
              </div>
              <div class="container-fluid">
                <div class="row">
                  <Button type="button" title="Remover Todos" class="p-button-primary mr-2 p-button-danger"
                    icon="pi pi-times" style="margin-right: 0.5em" @click="removerNotasDeclaracao()" :disabled="loading"
                    label="Remover Todos"></Button>
                </div>
              </div>
              <div class="container-fluid" style="padding-top: 5px">
                <div class="row">
                  <DataTable id="teste" :value="listNotasDeclaradas" :paginator="true" :rows="10" :key="1"
                    :autoLayout="true" style="min-width: 100%" ref="dt2" :filters="filtersModelNotasRet">
                    <Column headerStyle="width: 4em" header bodyStyle="text-align: center">
                      <template #body="slotProps">
                        <Button type="button" title="Remover" class="p-button-primary mr-2 p-button-danger"
                          icon="pi pi-times" style="margin-right: 0.5em" @click="removerNotaDeclaracao(slotProps.data)"
                          :disabled="loading"></Button>
                      </template>
                    </Column>
                    <Column headerStyle="width: 8em" field="tipo" header="Tipo" bodyStyle="text-align:right">
                      <template #filter>
                        <InputText type="text" v-model="filtersModelNotasRet['tipo']" class="p-column-filter"
                          placeholder="Iniciando com" style="width: 8em" />
                      </template>
                    </Column>
                    <Column headerStyle="width: 8em" field="numero" header="Número" bodyStyle="text-align:right">
                      <template #filter>
                        <InputText type="text" v-model="filtersModelNotasRet['numero']" class="p-column-filter"
                          placeholder="Iniciando com" style="width: 8em" />
                      </template>
                    </Column>
                    <Column headerStyle="width: 8em" field="dataEmissaoFormatada" header="Emissão" bodyStyle="text-align:right">
                      <template #filter>
                        <InputText type="text" v-model="filtersModelNotasRet['dataEmissaoFormatada']" class="p-column-filter"
                          placeholder="Iniciando com" style="width: 8em" />
                      </template>
                    </Column>
                    <Column headerStyle="width: 8em" field="dataGeracaoFormatada" header="Geração" bodyStyle="text-align:right">
                      <template #filter>
                        <InputText type="text" v-model="filtersModelNotasRet['dataGeracaoFormatada']" class="p-column-filter"
                          placeholder="Iniciando com" style="width: 8em" />
                      </template>
                    </Column>
                    <Column headerStyle="width: 8em" field="valorFormatado" header="Valor" bodyStyle="text-align:right">
                      <template #filter>
                        <InputText type="text" v-model="filtersModelNotasRet['valorFormatado']" class="p-column-filter"
                          placeholder="Iniciando com" style="width: 8em" />
                      </template>
                    </Column>
                    <Column headerStyle="width: 8em" field="prestador" header="Prestador" bodyStyle="text-align:right">
                      <template #filter>
                        <InputText type="text" v-model="filtersModelNotasRet['prestador']" class="p-column-filter"
                          placeholder="Iniciando com" style="width: 8em" />
                      </template>
                    </Column>
                  </DataTable>
                </div>
              </div>
            </div>
          </template>
          <template >
            <hr/>
              <Button @click="consultarNotasADN()" label="Consultar Notas ADN Nota Nacional" type="button"
                class="p-button-primary mr-2 p-button-success" icon="pi pi-file" :disabled="loading"/>
            <hr/>
          </template>
          <h4 class="panel-title">
            <span class="title" v-if="!displayRetificar">Notas Fiscais/DAPS em Aberto para realizar a Declaração.</span>
            <span class="title" v-if="displayRetificar">Adicione abaixo novas notas a Declaração.</span>
          </h4>
          <hr />
          <template>
            <Checkbox v-model="checkTodos" :binary="true" @change="selecionarTodos()" />
            <span style="padding-left: 5px; font-weight: bold; font-size: 12px">Selecionar Todos</span>
          </template>
          <div style="padding-top: 10px">
            <DataTable :value="listNotas" :paginator="true" :rows="10" :autoLayout="true" style="min-width: 100%"
              ref="dt2" :filters="filtersModelNotas">
              <Column headerStyle="width: 3%" field="selecionado" header >
                <template #body="slotProps">
                  <Checkbox v-model="slotProps.data.selecionado" :binary="true" />
                </template>
              </Column>
              <Column headerStyle="width: 1%">
                <template #body="slotProps">
                  <div class="dropdown">
                    <Button class="btn btn-primary" type="button" id="dropdownMenuButton" icon="pi pi-angle-down"
                      data-toggle="dropdown" title="Opções" aria-haspopup="true" aria-expanded="false"></Button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <button class="dropdown-item" type="button" :disabled="loading"
                        v-if="slotProps.data.notaFiscal && slotProps.data.notaFiscal.transmitidoNacional === 'I'"
                        @click="visualizarDanfse(slotProps.data.notaFiscal.id)">
                        <span class="pi pi-print mr-2"></span>DANFSE
                      </button>
                      <button class="dropdown-item" type="button" :disabled="loading"
                        v-if="!slotProps.data.notaFiscal || (slotProps.data.notaFiscal && slotProps.data.notaFiscal.transmitidoNacional !== 'I')"
                        @click="impressaoNota(slotProps.data.id)">
                        <span class="pi pi-print mr-2"></span>Imprimir
                      </button>
                      <button class="dropdown-item" type="button" :disabled="loading"
                        v-if="isNotaFiscal(slotProps.data.id)" @click="downloadXml(slotProps.data.id)">
                        <span class="pi pi-download mr-2"></span>Exportar
                      </button>
                      <button class="dropdown-item" type="button" :disabled="loading"
                        v-if="habilitarAceiteTomador && (slotProps.data.tipo === 'Nfse' || slotProps.data.tipo === 'DAPS/Prestador') && slotProps.data.tipoRecolhimento === 'R'"
                        @click="displayDialogAceiteTomador(slotProps.data)">
                        <span class="pi pi-ban mr-2"></span>Retenção Indevida
                      </button>
                      <button class="dropdown-item" type="button" :disabled="loading"
                        v-if="showRecusaDaps && slotProps.data.tipo === 'DAPS/Prestador'"
                        @click="displayDialogRecDaps(slotProps.data)">
                        <span class="pi pi-ban mr-2"></span>Recusa Declaração
                      </button>
                    </div>
                  </div>
                </template>
              </Column>
              <Column headerStyle="width: 8em" field="tipo" header="Tipo" bodyStyle="text-align:right">
                <template #filter>
                  <InputText type="text" v-model="filtersModelNotas['tipo']" class="p-column-filter"
                    placeholder="Iniciando com" style="width: 8em" />
                </template>
              </Column>

              <Column v-if="isExibirDataPagamento()" headerStyle="width: 10%" field="dataPagamentoFormatada"
                header="Data Pag." bodyStyle="text-align:right">
                <template #body="slotProps">
                  <InputText type="text" v-model="slotProps.data.dataPagamentoFormatada" class="p-column-filter"
                    placeholder="Data Pagamento" style="width: 8em" v-maska="'##/##/####'" />
                </template>
              </Column>

              <Column headerStyle="width: 10%" field="numero" header="Numero" bodyStyle="text-align:right">
                <template #filter>
                  <InputText type="text" v-model="filtersModelNotas['numero']" class="p-column-filter"
                    placeholder="Iniciando com" />
                </template>
              </Column>
              <Column headerStyle="width: 8em" field="dataEmissaoFormatada" header="Emissão"
                bodyStyle="text-align:center">
                <template #filter>
                  <InputText type="text" v-model="filtersModelNotas['dataEmissaoFormatada']" class="p-column-filter"
                    placeholder="Iniciando com" style="width: 8em" />
                </template>
              </Column>
              <Column headerStyle="width: 8em" field="dataGeracaoFormatada" header="Geração"
                bodyStyle="text-align:center">
                <template #filter>
                  <InputText type="text" v-model="filtersModelNotas['dataGeracaoFormatada']" class="p-column-filter"
                    placeholder="Iniciando com" style="width: 8em" />
                </template>
              </Column>
              <Column headerStyle="width: 12%" field="valorFormatado" header="Valor" bodyStyle="text-align:right">
                <template #filter>
                  <InputText type="text" v-model="filtersModelNotas['valorFormatado']" class="p-column-filter"
                    placeholder="Iniciando com" />
                </template>
              </Column>
              <Column field="prestador" header="Prestador">
                <template #filter>
                  <InputText type="text" v-model="filtersModelNotas['prestador']" class="p-column-filter"
                    placeholder="Iniciando com" />
                </template>
              </Column>
              <Column headerStyle="width: 6em" field="situacao" header="Situação" bodyStyle="text-align:center">
                <template #filter>
                  <InputText type="text" v-model="filtersModelNotas['situacao']" class="p-column-filter"
                    placeholder="Iniciando com" style="width: 6em" />
                </template>
              </Column>
            </DataTable>
          </div>
          <hr />
          <template v-if="!displayRetificar">
            <Button @click="declarar($event)" label="Declarar" type="button"
              class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading"
              v-if="!isBloqueado"/>
            <Button @click="declararParc()" label="Declarar Parcelado" type="button"
              class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading" v-if="false" />
          </template>
          <template v-else>
            <Button @click="adicionarNotasDeclaracao()" label="Adicionar" type="button" class="p-button-primary mr-2"
              icon="pi pi-check" :disabled="loading" v-if="!isBloqueado"/>
            <hr />
            <Button @click="retificarDeclaracao()" label="Retificar Declaração" type="button"
              class="p-button-primary mr-2 p-button-success" icon="pi pi-replay" :disabled="loading" v-if="!isBloqueado"/>
            <Button @click="hideRetificar()" label="Cancelar" type="button"
              class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" :disabled="loading" v-if="!isBloqueado"/>
          </template>
        </div>
      </div>
    </div>
    <Dialog class="test-box" header="Justificar Recusa de Declaração" :visible.sync="showDialogRecusaDaps" :modal="true"
      :closable="false" :style="{ width: '600px' }">
      <h1 class="titulo-header">
        Justificar Retificação
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showDialogRecusaDaps = false" />
      </h1><br />
      <div class="container">
        <div class="row">
          <div class="col-md-12 mb-2 mensagem-cancelamento">
            <p>Informe o motivo de Recusa da Declaração.</p>
          </div>
        </div>
        <div id="topo" class="row">
          <div class="col-md-12 mb-2">
            <label for="tipoTomador">Motivo de Recusa: *</label>
            <span class="p-fluid">
              <textarea v-model="dapsRecusa.motivoRecusa" rows="5" maxlength="500" />
            </span>
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog class="test-box" header="Retenção Indevida" :visible.sync="showDialogAceiteTomador" :modal="true"
      :closable="false" :style="{ width: '600px' }">
      <h1 class="titulo-header">
        Retenção Indevida
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showDialogAceiteTomador = false" />
      </h1><br />
      <div  v-if="notaSelecionada && notaSelecionada.id">
        <div class="row">
          <div class="col-md-12 mb-2 mensagem-cancelamento">
            <p style="font-weight: bold;" v-if="notaSelecionada.tipo === 'Nfse'">Ao confirmar esta ação você estará
              recusando a retenção deste nota fiscal, a responsabilidade do recolhimento do ISS passará a ser do
              Prestador.
            </p>
            <p style="font-weight: bold;" v-if="notaSelecionada.tipo === 'DAPS/Prestador'">Ao confirmar esta ação você
              estará recusando a retenção deste DAPS, o mesmo será Cancelado e o Prestador sera comunicado desta ação.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 mb-2 mensagem-cancelamento">
            <p>{{ this.notaSelecionada.tipo }} Selecionada, nº: {{ this.notaSelecionada.numero }}, Prestador: {{
              this.notaSelecionada.prestador }}.</p>
          </div>
        </div>
        <div id="topo" class="row">
          <div class="col-md-12 mb-2">
            <label for="tipoTomador">Motivo da Retenção Indevida: *</label>
            <span class="p-fluid">
              <textarea v-model="motivoRetencaoIndevida" rows="5" maxlength="500" />
            </span>
          </div>
        </div>
      </div>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button @click="saveRetencaoIndevida()" href="#topo" type="button" label="Confirmar"
              class="p-button-primary mr-2 p-button-success" icon="pi pi-check"
              :disabled="motivoRetencaoIndevida.trim() === ''" />
          </div>
          <div>
            <Button @click="showDialogAceiteTomador = false" type="button" label="Fechar"
              class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog class="test-box" header="Justificar Retificação" :visible.sync="showRetificarDecAnalise" :modal="true"
      :closable="false" :style="{ width: '600px' }">
      <h1 class="titulo-header">
        Justificar Retificação
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showRetificarDecAnalise = false" />
      </h1><br />
      <div class="container">
        <div class="row">
          <div class="col-md-12 mb-2 mensagem-cancelamento">
            <p>Informe o motivo de Retificação da Declaração.</p>
          </div>
        </div>
        <div id="topo" class="row">
          <div class="col-md-12 mb-2">
            <label for="tipoTomador">Observação: *</label>
            <span class="p-fluid">
              <textarea v-model="decAnalise.motivoRetificacao" rows="5" maxlength="500" />
            </span>
          </div>
        </div>
      </div>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button @click="saveMotivoRetifcacao()" href="#topo" type="button" label="Salvar"
              class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading" />
          </div>
          <div>
            <Button @click="closeDialogRetifAnalise" type="button" label="Fechar"
              class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Competência" :visible.sync="showSelectComp" :style="{ width: '30vw' }"
      :contentStyle="{ overflow: 'visible' }" :modal="true">
      <h1 class="titulo-header">
        Competência
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showSelectComp = false" />
      </h1><br />
      <span class="p-fluid">
        <Dropdown id="filtroAno" v-model="filtroAno" :options="listAnos" optionLabel="name"
          placeholder="Selecione um Ano" />
      </span>
      <span class="p-fluid">
        <Dropdown id="filtroMes" v-model="filtroMes" :options="listMeses" optionLabel="name"
          placeholder="Selecione um Mês" />
      </span>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Selecionar" icon="pi pi-check" @click="pesquisar()" :disabled="loading" class="mr-2"/>
            <Button label="Fechar" icon="pi pi-times" @click="fecharSelectCompetencia()" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Aviso" :visible.sync="displayDecSemMov" :style="{ width: '30vw' }" :modal="true">
      Confirma realizar a Declaração sem Movimento para Competência?
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Sim" icon="pi pi-check" @click="declararSemMovimento()" :disabled="loading" class="mr-2"/>
            <Button label="Não" icon="pi pi-times" @click="hideDecSemMov()" class="p-button-secondary" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Imprimir Boleto" :visible.sync="displayVencBoleto" :style="{ width: '30vw' }"
      :contentStyle="{ overflow: 'visible' }" :modal="true">
      <h1 class="titulo-header">
        Imprimir Boleto
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="displayVencBoleto = false" />
      </h1><br />
      <div class="col-md-8 mb-8">
        <label for="dataVencBoleto">Data de Vencimento: *</label>
        <span class="p-fluid">
          <Calendar :disabled="disableDataVencDam" id="dataVencBoleto" :key="dtVencBoleto" name="dataVencBoleto"
            v-model="dataVencimento" :showIcon="true" dateFormat="dd/mm/yy" @date-select="vencimentoSelect()" />
        </span>
      </div>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Sim" icon="pi pi-check" @click="imprimirBoleto()" v-if="tipoEmissaoBoleto === 'N'"
              :disabled="loading" class="mr-2"/>
            <Button label="Sim" icon="pi pi-check" @click="imprimirBoletoPix()" v-if="tipoEmissaoBoleto === 'P'"
              :disabled="loading" class="mr-2"/>
            <Button label="Não" icon="pi pi-times" @click="hideVencBoleto()" class="p-button-secondary" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Boleto" :visible.sync="displayBoletos" :style="{ width: '38vw' }" :modal="true">
      <h1 class="titulo-header">
        Boleto
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="displayBoletos = false" />
      </h1><br />

      <DataTable :value="listBoletos" :paginator="true" :rows="10" :autoLayout="true" style="min-width: 100%">
        <Column headerStyle="width: 4em" header bodyStyle="text-align: center">
          <template #body="slotProps">
            <div class="d-flex align-items-center">
              <Button type="button" title="Imprimir Boleto" class="p-button-primary mr-2" icon="pi pi-print"
                style="margin-right: 0.5em" @click="
                  carregarVencimentoBoleto(
                    slotProps.data.id,
                    slotProps.data.dataVencimento,
                    'N'
                  )
                  " :disabled="loading" v-if="slotProps.data.pagamentoEfetuado == 'N'"></Button>
              <Button type="button" title="Pagar com PIX" class="p-button-outlined mr-2" icon="pi pix-icon"
                style="margin-right: 0.5em" @click="
                  escolhaPagamentoPix(
                    slotProps.data.id,
                    slotProps.data.dataVencimento
                  )
                  " :disabled="loading" v-if="slotProps.data.pagamentoEfetuado == 'N' && habilitarPix"></Button>
              <Button title="Consultar Pagamento PIX" icon="pi pi-search" style="margin-right: 0.5em"
                @click="consultarPagamentoPix(slotProps.data.id)" :disabled="loading"
                v-if="slotProps.data.pagamentoEfetuado == 'N' && habilitarPix" />
            </div>
          </template>
        </Column>
        <Column headerStyle="width: 15%" field="vencimentoFormatado" header="Vencimento" bodyStyle="text-align:right">
        </Column>
        <Column field="valorFormatado" header="Valor" bodyStyle="text-align:center"></Column>
      </DataTable>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Fechar" icon="pi pi-times" @click="hideBoletos()" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Lançamentos Avulsos" :visible.sync="displayAvulsos" :style="{ width: '60vw' }" :modal="true">
      <h1 class="titulo-header">
        Lançamentos Avulsos
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="displayAvulsos = false" />
      </h1><br />
      <DataTable :value="listAvulsos" :paginator="true" :rows="5" :autoLayout="true" style="min-width: 100%">
        <Column headerStyle="width: 4em" header="Recibo" bodyStyle="text-align: center">
          <template #body="slotProps">
            <Button type="button" title="Imprimir Recibo" class="p-button-primary mr-2" icon="pi pi-print"
              style="margin-right: 0.5em" @click="impressaoComprovante(slotProps.data.id)" :disabled="loading"></Button>
          </template>
        </Column>
        <Column headerStyle="width: 10%" field="numero" header="Número" bodyStyle="text-align:right"></Column>
        <Column headerStyle="width: 8em" field="dataFormatada" header="Data" bodyStyle="text-align:center"></Column>
        <Column headerStyle="width: 8em" field="tomador" header="Contribuinte" bodyStyle="text-align:center"></Column>
        <Column headerStyle="width: 8em" field="valor" header="Valor" bodyStyle="text-align:center"></Column>
        <Column headerStyle="width: 8em" field="aliquota" header="Alíquota" bodyStyle="text-align:center"></Column>
        <Column headerStyle="width: 8em" field="iss" header="ISS" bodyStyle="text-align:center"></Column>
      </DataTable>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Fechar" icon="pi pi-times" @click="hideAvulsos()" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog :visible.sync="showEscolhaPix" :style="{ width: '30vw' }" :contentStyle="{ overflow: 'visible' }"
      :modal="true">
      <template #header>
        <Button class="p-button-outlined mr-2" icon="pi pix-icon" />
        <h3>Pagar com PIX</h3>
      </template>
      <div class="col-md-8 mb-8">
        <Button label="QR Code" icon="pi pi-bars" @click="criarPagamentoPix()" style="margin-right: 0.5em"
          :disabled="loading" />
        <Button label="Boleto" icon="pi pi-print" @click="
          carregarVencimentoBoleto(idDamAgrupamento, dataVencimento, 'P')
          " :disabled="loading" />
      </div>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Fechar" icon="pi pi-times" @click="showEscolhaPix = false" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog :visible.sync="showPix" :style="{ width: '40vw' }" :modal="true">
      <template #header>
        <Button class="p-button-outlined mr-2" icon="pi pix-icon" />
        <h3>Pagar com PIX</h3>
      </template>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6 mb-2">
            <QRCanvas :options="optionsPix" />
          </div>
          <div class="col-md-6 mb-2">
            <div style="padding-top: 20px">
              Utilize o App de sua Instituição Financeira, na opção PIX escolha
              pagar com QR Code, confirme os dados e realize o Pagamento. <br />
              <br /><span style="font-weight: bold">Valor Total:
                {{ this.pixGerado ? this.pixGerado.valorFormatado : 0 }}</span>
            </div>
          </div>
        </div>
        <div class="row" v-if="this.pixGerado && this.pixGerado.qrCode">
          <div class="col-md-12 mb-2">
            <Button label="Copiar Código PIX" icon="pi pi-copy" @click="copiarPix()" />
          </div>
        </div>
      </div>

      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Fechar" icon="pi pi-times" @click="showPix = false" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Pesquisar Declaração por Nfse" :visible.sync="showPesqNota" :style="{ width: '30vw' }"
      :contentStyle="{ overflow: 'visible' }" :modal="true">
      <h1 class="titulo-header">
        Pesquisar Declaração por Nfse
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showPesqNota = false" />
      </h1><br />
      <span class="p-fluid">
        <InputText v-model="numeroNfsePesquisa" placeholder="Número Nfse" />
      </span>
      <span class="p-fluid">
        <InputText v-model="filtro" placeholder="CPF/CNPJ/Nome Prestador" />
      </span>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Pesquisar" icon="pi pi-check" @click="pesquisarPorNota()" :disabled="loading" class="mr-2"/>
            <Button label="Fechar" icon="pi pi-times" @click="showPesqNota = false" class="p-button-danger" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Aplicar Créditos" :visible.sync="showAplicarCredito" v-if="dadosCredito != null"
      :style="{ width: '30vw' }" :contentStyle="{ overflow: 'visible' }" :modal="true">
      <h1 class="titulo-header">
        Aplicar Créditos
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showAplicarCredito = false" />
      </h1><br />
      <div class="col-md-10 mb-8" v-if="dadosCredito.valorCreditoAplicado <= 0">
        <label style="font-weight: bold;">O município possibilita a aplicação do saldo de crédito abaixo até o
          percentual
          limite de: {{ dadosCredito.percentualLimiteAbatimentoCredito }}%. </label>
      </div>
      <div class="col-md-8 mb-8">
        <label for="dataVencBoleto">Declaracao Selecionada: </label>
        <span class="p-fluid" v-if="declaracaoSelecionada && declaracaoSelecionada.numero">
          <InputText v-model="declaracaoSelecionada.numero" disabled="true" />
        </span>
      </div>
      <div class="col-md-10 mb-8" v-if="dadosCredito.valorCreditoAplicado > 0">
        <label style="font-weight: bold;">Esta declaração ja possui um crédito aplicado no valor de: {{
          dadosCredito.valorCreditoAplicado }}, não é possível aplicar mais de um crédito. </label>
      </div>
      <div class="col-md-8 mb-8" v-if="dadosCredito.valorCreditoAplicado <= 0">
        <label for="dataVencBoleto">Saldo Crédito Disponível: </label>
        <span class="p-fluid">
          <InputText v-model="dadosCredito.saldoCredito" disabled="true" />
        </span>
      </div>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Aplicar" icon="pi pi-check" @click="aplicarCredito()" :disabled="loading"
              v-if="dadosCredito.valorCreditoAplicado <= 0" class="mr-2"/>
            <Button label="Fechar" icon="pi pi-times" @click="showAplicarCredito = false" :disabled="loading"
              class="p-button-secondary" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Cancelamento de Taxa" :visible.sync="displayCancelarTaxa" :style="{ width: '30vw' }" :modal="true">
      <h1 class="titulo-header">
        Cancelamento de Taxa
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="displayBoletos = false" />
      </h1><br />
      Informe o motivo do Cancelamento:
      <textarea v-model="motivoCancelamentoTaxa" rows="5" maxlength="500" />
      <hr/>
      <div class="container">
        <div class="row">
          <div>
            <Button label="Confirmar" icon="pi pi-check" @click="cancelarTaxa()" class="mr-2" :disabled="loading"/>
            <Button label="Voltar" icon="pi pi-times" @click="displayCancelarTaxa = false" class="p-button-secondary" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog header="Transferência de Valores" :visible.sync="showTransfValores" :style="{ width: '30vw' }" :modal="true"
      v-if="declaracaoSelecionada">
      <h1 class="titulo-header">
        Transferência de Valores
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showTransfValores = false" />
      </h1><br />
      Declaração Selecionada: {{ declaracaoSelecionada.numero }}<br /><br />
      ATENÇÃO! Essa opção deve ser utilizada para transferir os calculos/valores da declaração selecionada para outra,
      nos casos onde há pagamento em declarações canceladas/retificadas e pagas.
      caso confirme a operação informe abaixo o numero de declaração de destino
      <hr />
      <span class="p-fluid">
        <InputText v-model="numeroDeclaracaoDestino" placeholder="Número Declaração Destino" />
      </span>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Transferir" icon="pi pi-check" @click="transferirCalculos()" class="mr-2"/>
            <Button label="Fechar" icon="pi pi-times" @click="showTransfValores = false" class="p-button-secondary" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog :header="estadoSuspensao === 'S' ? 'Suspender Guia' : 'Cancelar Suspenso Processo'"
      :visible.sync="showSuspensao" :style="{ width: '30vw' }" :modal="true"
      v-if="declaracaoSelecionada && estadoSuspensao">
      <h1 class="titulo-header">
        {{ estadoSuspensao === 'S' ? 'Suspender Guia' : 'Cancelar Suspenso Processo' }}
        <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
          @click="showSuspensao = false" />
      </h1><br />
      Declaração Selecionada: {{ declaracaoSelecionada.numero }}<br /><br />
      Confirma {{ estadoSuspensao === 'S' ? 'a Suspenção da Guia' : 'o Cancelamento do Suspenso Processo' }}?
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button label="Sim" icon="pi pi-check" @click="efetivarSuspensao()" class="mr-2"/>
            <Button label="Fechar" icon="pi pi-times" @click="showSuspensao = false" class="p-button-secondary" />
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog 
      :visible.sync="showAutoInfracao"
      :style="{ width: '40vw' }"
      :modal="true"
    >
    <h1 class="titulo-header">Auto de Infração</h1>
    <hr/>
      <div style="padding: 1.5rem;">
        <small class="subtitle">Referente ao Auto de Infração de Número:</small>
        <div class="text-center mt-3">
          <input 
            v-model="dadosAutoInfracao"
            disabled
            class="p-inputtext custom-input"
          />
        </div>
        <hr class="custom-divider" style="margin: 1.5rem 0;" />
        <div class="flex justify-content-center">
          <Button 
            label="Fechar" 
            icon="pi pi-times" 
            @click="showAutoInfracao = false"
            class="p-button-danger"
          />
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import DeclaracaoSubstituicao from "../services/tributario/declaracao.substituicao.service";
import DeclaracaoService from "../services/tributario/declaracao.service";
import NotaFiscalService from "@/services/nfse/notafiscal.service";
import DeclaracaoRetificacaoService from "../services/tributario/declaracao.retificacao.service";
import RetificarDeclaracaoAnalise from "../models/tributario/RetificarDeclaracaoAnalise";
import Daps from "../models/nfse/Daps";
import DapsRecusaMotivoModel from "../models/nfse/DapsRecusaMotivoModel";
import DapsService from "../services/nfse/daps.service";
import LoginService from "../services/acesso/login.service";
import ReportService from "../services/report.service";
import GpiService from "../services/nfse/gpi.service";
import { QRCanvas } from "qrcanvas-vue";
import ConsultaNotaNacional from "../components/emissaoNfse/ConsultaNotaNacional";
/* eslint-disable */
export default {
  name: "declaracaoSubstituicao",
  components: {
    ConsultaNotaNacional,
    QRCanvas,
  },
  data() {
    return {
      apresentacao: false,
      filtersModel: {},
      filtersModelNotas: {},
      filtersModelNotasRet: {},
      dtVencBoleto: 1,
      dtVenc: 0,
      inativo: false,
      competencia: "",
      checkTodos: false,
      loading: false,
      filtro: "",
      filtroAno: "",
      filtroMes: "",
      listAnos: [],
      listMeses: [],
      listDeclaracao: [],
      listNotas: [],
      filters: {},
      currentUser: null,
      competenciaLimite: null,
      showSelectComp: false,
      displayDecSemMov: false,
      showImpressaoBoletos: false,
      idDeclaracaoSelecionada: null,
      dataVencimento: null,
      listNotasDeclaradas: [],
      declaracaoSelecionada: null,
      displayRetificar: false,
      displayBoletos: false,
      listBoletos: [],
      listTaxas: [],
      taxaSelecionada: null,
      motivoCancelamentoTaxa: null,
      displayCancelarTaxa: false,
      displayAvulsos: false,
      listAvulsos: [],
      tipoEmissaoBoleto: "N",
      idDecLancamentoSelecionado: null,
      idDamAgrupamento: null,
      displayVencBoleto: false,
      habilitarPix: false,
      habilitarCredito: false,
      showPix: false,
      showEscolhaPix: false,
      optionsPix: {
        cellSize: 5,
        data: "hello",
      },
      pixGerado: null,
      observacaoClienteNfse: false,
      numeroNfsePesquisa: '',
      showPesqNota: false,
      showRetificarDecAnalise: false,
      habilitarRecDaps: null,
      showRecusaDaps: false,
      showDialogRecusaDaps: false,
      motivoRecDaps: null,
      dapsSelecionada: null,
      decAnalise: new RetificarDeclaracaoAnalise(),
      dapsRecusa: new DapsRecusaMotivoModel(),
      daps: new Daps(),
      showTransfValores: false,
      numeroDeclaracaoDestino: null,
      showSuspensao: false,
      estadoSuspensao: null,
      dadosCredito: null,
      showAplicarCredito: false,
      boletos: false,
      admin: false,
      vencimentoAnterior: null,
      disableDataVencDam: false,
      travaDam: null,
      habilitarAceiteTomador: false,
      notaSelecionada: null,
      showDialogAceiteTomador: false,
      motivoRetencaoIndevida: '',
      habilitarNotaNacional : false,
      showAutoInfracao: false,
      dadosAutoInfracao: null
    };
  },

  created() {
    this.apresentacao = (this.$apresentacao ? this.$apresentacao : false);
    this.competenciaLimite = new Date();
    this.competenciaLimite.setMonth(this.competenciaLimite.getMonth());
    this.currentUser = LoginService.currentUserValue;
    console.log(this.currentUser.configuracao);
    
    this.habilitarAceiteTomador = this.currentUser.configuracao.idBolAceiteTomador === 'S';
    this.habilitarRecDaps = this.currentUser.configuracao.idBolRecusaDeclaracao;
    this.habilitarPix = this.currentUser.configuracao.idBolUtilizarPix === "S";
    this.habilitarCredito = this.currentUser.configuracao.idBolCreditoHabilitado === "S";
    this.inativo =
      this.currentUser && this.currentUser.contribuinte
        ? !this.currentUser.contribuinte.ativo
        : false;
    this.observacaoClienteNfse =
      this.currentUser.configuracao.idBolObservacaoNfse === "S";
    this.carregarAnos();
    this.carregarMeses();
    this.carregarCompetenciaAtual();
    this.displayRecusaDaps();
    this.pesquisar();
    this.admin = this.currentUser.usuario.idBolAdmin;
    this.travaDam = this.currentUser.configuracao.nfDiasTravaPagamentoBoleto;
    this.habilitarNotaNacional = this.currentUser.configuracao.idBolIntegraNfseNacional === "S";
  },

  methods: {
    imprimirAutoInfracao(idDeclaracao){
      DeclaracaoService.obterDadosAutoInfracao(idDeclaracao).then(
        data =>{
          this.dadosAutoInfracao = data.data;
          console.log(data);
        },
        error => {
          console.log(error);
        }
      )
      this.showAutoInfracao = true;
    },
    openSuspensao(declaracao, estado) {
      this.declaracaoSelecionada = declaracao;
      this.estadoSuspensao = estado;
      this.showSuspensao = true;
    },
    efetivarSuspensao() {
      this.processando(true);
      if (this.estadoSuspensao === 'S') {
        DeclaracaoSubstituicao.suspenderGuia(
          this.currentUser.usuario.idUsuario,
          this.declaracaoSelecionada.id
        )
          .then((response) => {
            console.log(response);
            this.pesquisar();
            this.showSuspensao = false;
            this.$root.$emit(
              "alert:success",
              "Suspensão de Guia realizada com sucesso!"
            );
          },
            (error) => {
              console.log(error);
              this.$root.$emit("alert:warn", error.response.data);
            }
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        DeclaracaoSubstituicao.cancelarSuspencaoGuia(
          this.currentUser.usuario.idUsuario,
          this.declaracaoSelecionada.id
        )
          .then((response) => {
            console.log(response);
            this.pesquisar();
            this.showSuspensao = false;
            this.$root.$emit(
              "alert:success",
              "Cancelamento Suspenso Processo realizado com sucesso!"
            );
          },
            (error) => {
              console.log(error);
              this.$root.$emit("alert:warn", error.response.data);
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
    },
    async openTransferirCalculoes(declaracao) {
      this.declaracaoSelecionada = declaracao;
      this.idDeclaracaoSelecionada = declaracao.id;
      this.showTransfValores = true;
      this.numeroDeclaracaoDestino = null;
    },
    transferirCalculos() {
      this.processando(true);
      DeclaracaoSubstituicao.transferirCalculosDeclaracao(
        this.idDeclaracaoSelecionada,
        this.numeroDeclaracaoDestino
      )
        .then((response) => {
          console.log(response);
          this.pesquisar();
          this.showTransfValores = false;
          this.$root.$emit(
            "alert:success",
            "Transferência realizada com sucesso!"
          );
        },
          (error) => {
            console.log(error);
            this.$root.$emit("alert:warn", error.response.data);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    vencimentoSelect() {
      let dateSelect = this.dataVencimento;
      if (dateSelect) {
        dateSelect.setHours(8);
      }
    },
    copiarPix() {
      navigator.clipboard.writeText(this.pixGerado.qrCode);
    },
    rowClass(data) {
      return data.status === "Cancelada" || data.status === "Retificada"
        ? "red-row"
        : data.status === "Encerrada"
          ? "green-row"
          : null;
    },
    lineClass(data) {
      return data.status === "Cancelada" ||
        data.status === "Retificada" ||
        data.status === "Encerrada"
        ? "white-line"
        : null;
    },
    rolarPagina() {
      document.getElementById("topo").scrollIntoView({
        behavior: "smooth",
      });
    },
    alterarCompetencia() {
      this.showSelectComp = true;
    },
    fecharSelectCompetencia() {
      this.showSelectComp = false;
    },
    showNotaDam() {
      this.showPesqNota = true;
    },
    displayRecusaDaps() {
      if (this.habilitarRecDaps === 'S') {
        this.showRecusaDaps = true;
      } else if (this.habilitarRecDaps === 'N') {
        this.showRecusaDaps = false;
      }
    },
    displayDialogRecDaps(dapsSelecionada) {
      this.dapsSelecionada = dapsSelecionada;
      this.showDialogRecusaDaps = true;
    },
    displayDialogAceiteTomador(nota) {
      this.notaSelecionada = nota;
      this.motivoRetencaoIndevida = '';
      this.showDialogAceiteTomador = true;
    },

    closeDialogRecDaps() {
      this.limparDadosRecDaps();
      this.showDialogRecusaDaps = false;
    },
    pesquisarPorNota() {
      if (this.numeroNfsePesquisa.trim() === '' && this.filtro.trim() === '') {
        this.showPesqNota = false;
        this.pesquisar();
        return;
      }
      this.processando(true);

      let novaCompetencia =
        this.filtroAno.key +
        "" +
        this.formatted_string("00", this.filtroMes.key, "l");
      let compMax =
        this.competenciaLimite.getFullYear() +
        "" +
        this.formatted_string("00", this.competenciaLimite.getMonth() + 1, "l");

      if (parseInt(novaCompetencia) > parseInt(compMax)) {
        this.$root.$emit("alert:warn", "Competência ainda não disponivel!");
        this.processando(false);
        return;
      }

      this.competencia = this.filtroMes.name + "/" + this.filtroAno.key;
      DeclaracaoSubstituicao.findAllDeclaracoesNumero(
        this.currentUser.contribuinte.idContribuinte,
        this.filtroAno.key,
        this.filtroMes.key,
        this.numeroNfsePesquisa,
        this.filtro
      ).then((response) => {
        this.listDeclaracao = response.data;
      }).then(() => {
        this.showPesqNota = false;
        this.processando(false);
      });

    },
    async pesquisar() {
      this.processando(true);

      let novaCompetencia =
        this.filtroAno.key +
        "" +
        this.formatted_string("00", this.filtroMes.key, "l");
      let compMax =
        this.competenciaLimite.getFullYear() +
        "" +
        this.formatted_string("00", this.competenciaLimite.getMonth() + 1, "l");

      if (parseInt(novaCompetencia) > parseInt(compMax)) {
        this.$root.$emit("alert:warn", "Competência ainda não disponivel!");
        this.processando(false);
        return;
      }

      this.competencia = this.filtroMes.name + "/" + this.filtroAno.key;

      await this.carregarNotasEmAberto();
      await this.carregarDeclaracoes();
      await this.carregarTaxas();

      this.showSelectComp = false;
      this.processando(false);
    },
    async carregarNotasEmAberto() {
      return DeclaracaoSubstituicao.findAllNotasEmAberto(
        this.currentUser.contribuinte.idContribuinte,
        this.filtroAno.key,
        this.filtroMes.key
      ).then((responseNota) => {
        this.listNotas = responseNota.data;
        console.log(this.listNotas);
      })
    },
    async carregarDeclaracoes() {
      return DeclaracaoSubstituicao.findAllDeclaracoes(
        this.currentUser.contribuinte.idContribuinte,
        this.filtroAno.key,
        this.filtroMes.key
      ).then((response) => {
        this.listDeclaracao = response.data;
      })
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },
    carregarAnos() {
      let ano = this.competenciaLimite.getFullYear();
      // eslint-disable-next-line
      for (var i = ano; i > ano - 16; i--) {
        this.listAnos.push({ name: i, key: i });
      }
    },
    carregarMeses() {
      this.listMeses.push({ name: "Janeiro", key: 1 });
      this.listMeses.push({ name: "Fevereiro", key: 2 });
      this.listMeses.push({ name: "Março", key: 3 });
      this.listMeses.push({ name: "Abril", key: 4 });
      this.listMeses.push({ name: "Maio", key: 5 });
      this.listMeses.push({ name: "Junho", key: 6 });
      this.listMeses.push({ name: "Julho", key: 7 });
      this.listMeses.push({ name: "Agosto", key: 8 });
      this.listMeses.push({ name: "Setembro", key: 9 });
      this.listMeses.push({ name: "Outubro", key: 10 });
      this.listMeses.push({ name: "Novembro", key: 11 });
      this.listMeses.push({ name: "Dezembro", key: 12 });
    },
    carregarCompetenciaAtual() {
      let ano = this.competenciaLimite.getFullYear();
      let mes = this.competenciaLimite.getMonth();
      mes = mes + 1;

      //Três Corações usa a competência anterior da atual como tela inicial
      if (this.currentUser.usuario.idCliente === 'F58DEFAB039A9DB0F91C6B13F7C32A46') {
        mes = mes - 1;
        if (mes < 1) {
          mes = 12;
          ano = ano - 1;
        }
      }

      this.filtroAno = this.listAnos.filter((local) => local.key == ano)[0];
      this.filtroMes = this.listMeses.filter((local) => local.key == mes)[0];
      this.competencia = this.filtroMes.name + "/" + ano;
    },
    selecionarTodos() {
      if (this.checkTodos) {
        this.listNotas.forEach(function (value) {
          value.selecionado = true;
        });
      } else {
        this.listNotas.forEach(function (value) {
          value.selecionado = false;
        });
      }
    },
    declarar(event) {
      //solução feita para evitar duplo click e o evento acontecer 2 vezes causando problemas de duplicidade de declaração
      if (!event.detail || event.detail == 1) {
        this.processando(true);
        if (
          (!this.listNotas || this.listNotas.length <= 0) &&
          (!this.listDeclaracao || this.listDeclaracao.length <= 0)
        ) {
          this.confirmaDeclararSemMovimento();
          return;
        }
        let checked = false;
        this.listNotas.forEach(function (value) {
          if (value.selecionado) {
            checked = true;
            return;
          }
        });
        if (!checked) {
          this.$root.$emit(
            "alert:warn",
            "Selecione ao menos uma nota para realizar a Declaração!"
          );
          this.processando(false);
        } else {
          this.declararNotas(false);
        }
      }
    },
    declararParc() {
      this.processando(true);
      if (
        (!this.listNotas || this.listNotas.length <= 0) &&
        (!this.listDeclaracao || this.listDeclaracao.length <= 0)
      ) {
        this.confirmaDeclararSemMovimento();
        return;
      }
      let checked = false;
      this.listNotas.forEach(function (value) {
        if (value.selecionado) {
          checked = true;
          return;
        }
      });
      if (!checked) {
        this.$root.$emit(
          "alert:warn",
          "Selecione ao menos uma nota para realizar a Declaração!"
        );
        this.processando(false);
      } else {
        this.declararNotas(true);
      }
      this.processando(false);
    },
    confirmaDeclararSemMovimento() {
      this.processando(false);
      this.displayDecSemMov = true;
    },
    hideDecSemMov() {
      this.displayDecSemMov = false;
    },
    declararSemMovimento() {
      DeclaracaoSubstituicao.declararSemMov(
        this.currentUser.usuario.idCliente,
        this.currentUser.usuario.idUsuario,
        this.currentUser.contribuinte.idContribuinte,
        this.filtroAno.key,
        this.filtroMes.key
      ).then((response) => {
        console.log(response);
        this.pesquisar();
        this.$root.$emit(
          "alert:success",
          "Declaração sem Movimento gerada com sucesso!"
        );
      });
      this.displayDecSemMov = false;
    },
    declararNotas(parc) {
      let listNotasSelecionadas = [];
      this.listNotas.forEach(function (value) {
        if (value.selecionado) {
          value.dataPagamento = value.dataPagamentoFormatada;
          listNotasSelecionadas.push(value);
        }
      });
      if (parc) {
        DeclaracaoSubstituicao.declararParc(
          this.currentUser.usuario.idCliente,
          this.currentUser.usuario.idUsuario,
          this.currentUser.contribuinte.idContribuinte,
          this.filtroAno.key,
          this.filtroMes.key,
          "N",
          listNotasSelecionadas
        )
          .then(
            (response) => {
              console.log(response);
              this.pesquisar();
              this.$root.$emit("alert:success", "Declaração gerada com sucesso!");
            },
            (error) => {
              console.log(error);
              this.$root.$emit("alert:error", error.response.data);
            }
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        DeclaracaoSubstituicao.declarar(
          this.currentUser.usuario.idCliente,
          this.currentUser.usuario.idUsuario,
          this.currentUser.contribuinte.idContribuinte,
          this.filtroAno.key,
          this.filtroMes.key,
          "N",
          listNotasSelecionadas
        )
          .then(
            (response) => {
              console.log(response);
              this.pesquisar();
              this.$root.$emit("alert:success", "Declaração gerada com sucesso!");
            },
            (error) => {
              console.log(error);
              this.$root.$emit("alert:error", error.response.data);
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
    },
    cancelarDeclaracao(idDeclaracao) {
      this.processando(true);
      DeclaracaoSubstituicao.cancelar(
        this.currentUser.usuario.idUsuario,
        this.currentUser.contribuinte.idContribuinte,
        idDeclaracao
      )
        .then((response) => {
          console.log(response);
          this.pesquisar();
          this.$root.$emit(
            "alert:success",
            "Declaração cancelada com sucesso!"
          );
        })
        .then(() => {
          this.processando(false);
        });
    },
    async carregarDadosCredito(idDeclaracao) {
      return DeclaracaoService.carregarDadosCredito(
        this.currentUser.usuario.idUsuario,
        idDeclaracao
      )
        .then((response) => {
          console.log(response);
          this.dadosCredito = response.data;
        },
          (error) => {
            console.log(error);
            this.$root.$emit("alert:warn", error.response.data);
          }
        )

    },
    async showDiaglogAplicarCredito(declaracao) {
      this.processando(true);
      this.dadosCredito = null;
      this.declaracaoSelecionada = declaracao;
      await this.carregarDadosCredito(declaracao.id);
      let possuiSaldo = false;
      if (this.dadosCredito != null && this.dadosCredito.saldoCredito && this.dadosCredito.saldoCredito > 0) {
        possuiSaldo = true
      }
      if (!possuiSaldo) {
        this.$root.$emit("alert:warn", "Contribuinte não possui crédito disponivel para aplicar!");
        this.processando(false);
        return;
      }
      this.showAplicarCredito = true;
      this.processando(false);

    },
    aplicarCredito() {
      this.processando(true);
      DeclaracaoService.aplicarCredito(
        this.currentUser.usuario.idUsuario,
        this.declaracaoSelecionada.id
      )
        .then((response) => {
          console.log(response);
          this.pesquisar();
          this.showAplicarCredito = false;
          this.$root.$emit(
            "alert:success",
            "Crédito aplicado com sucesso!"
          );
        },
          (error) => {
            console.log(error);
            this.$root.$emit("alert:warn", error.response.data);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    encerrarDeclaracao(id) {
      this.idDeclaracaoSelecionada = id;
      this.processando(true);
      DeclaracaoSubstituicao.encerrar(
        this.currentUser.usuario.idCliente,
        this.currentUser.usuario.idUsuario,
        this.currentUser.contribuinte.idContribuinte,
        this.idDeclaracaoSelecionada
      )
        .then(
          (response) => {
            console.log(response);
            this.pesquisar();
            this.$root.$emit(
              "alert:success",
              "Declaração encerrada com sucesso!"
            );
          },
          (error) => {
            console.log(error);
            let erro = "Não foi possível encerrar a Declaração, verifique com o administrador do sistema se o Serviço de Geração de DAM esta disponível!";
            if (error.response && error.response.data) {
              erro = error.response.data;
            }
            this.$root.$emit(
              "alert:error",
              erro
            );
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    async carregarRetificacao(declaracao) {
      this.declaracaoSelecionada = declaracao;

      this.dadosCredito = null;
      await this.carregarDadosCredito(declaracao.id);
      if (this.dadosCredito != null && this.dadosCredito.valorCreditoAplicado && this.dadosCredito.valorCreditoAplicado > 0) {
        this.$root.$emit(
          "alert:warn",
          "Não será possível Retificar a declaração, pois foi aplicado um valor de crédito!"
        );
        return;
      }

      this.processando(true);
      DeclaracaoRetificacaoService.validarDeclaracao(this.declaracaoSelecionada.id)
        .then((responseValidacao) => {
          const erros = responseValidacao.data;
          if (erros.length > 0) {
            this.$root.$emit("alert:warn", erros[0]);
            return;
          }

        DeclaracaoService.competenciaEmFiscalizacao(this.declaracaoSelecionada.id)
          .then((responseFisc) => {
            console.log(responseFisc);
            let comp = this.declaracaoSelecionada.ano + '/' + this.declaracaoSelecionada.mes;
            if (responseFisc.data === 'S') {
              this.$root.$emit(
                "alert:warn",
                "Não sera possível Retificar a declaração, Contribuinte em processo de Fiscalização para o período: " + comp + " !"
              );
              return;
            }

            if (this.isAnaliseRetificacao) {
              this.showDialogRetifAnalise()
            } else {
              DeclaracaoService.carregarNotasDeclaracao(this.declaracaoSelecionada.id)
                .then((response) => {
                  console.log(response);
                  this.listNotasDeclaradas = response.data;
                  this.displayRetificar = true;
                })
            }
          })
      })
      .then(() => {
        this.processando(false);
      });
    },
    hideRetificar() {
      this.processando(true);
      this.declaracaoSelecionada = null;
      this.displayRetificar = false;
      this.pesquisar();
      this.rolarPagina();
      this.processando(false);
    },
    adicionarNotasDeclaracao() {
      this.processando(true);
      for (let i = this.listNotas.length - 1; i >= 0; i--) {
        if (this.listNotas[i].selecionado) {
          this.listNotasDeclaradas.push(this.listNotas[i]);
          this.listNotas.splice(i, 1);
        }
      }
      this.listNotasDeclaradas.sort(function (a, b) {
        return parseFloat(b.numero) - parseFloat(a.numero);
      });
      this.rolarPagina();
      this.processando(false);
    },
    removerNotaDeclaracao(notaDec) {
      this.processando(true);
      notaDec.selecionado = false;
      this.listNotas.push(notaDec);
      this.listNotasDeclaradas.forEach(function (item, index, object) {
        if (item.id === notaDec.id) {
          object.splice(index, 1);
        }
      });
      this.listNotas.sort(function (a, b) {
        return parseFloat(b.numero) - parseFloat(a.numero);
      });
      this.rolarPagina();
      this.processando(false);
    },
    removerNotasDeclaracao() {
      this.processando(true);
      let newList = this.listNotas.slice();
      this.listNotasDeclaradas.forEach(function (item) {
        newList.push(item);
      });
      this.listNotas = newList;
      this.listNotasDeclaradas = [];
      this.listNotas.sort(function (a, b) {
        return parseFloat(b.numero) - parseFloat(a.numero);
      });
      this.rolarPagina();
      this.processando(false);
    },
    retificarDeclaracao() {
      this.processando(true);
      DeclaracaoSubstituicao.retificar(
        this.currentUser.usuario.idUsuario,
        this.currentUser.contribuinte.idContribuinte,
        this.currentUser.usuario.idCliente,
        this.declaracaoSelecionada.id,
        this.listNotasDeclaradas
      )
        .then((response) => {
          console.log(response);
          this.pesquisar();
          this.$root.$emit(
            "alert:success",
            "Declaração retificada com sucesso!"
          );
          this.hideRetificar();
        },
          (error) => {
            console.log(error);
            let erro = "";
            if (error.response && error.response.data) {
              erro = error.response.data;
            }
            this.$root.$emit(
              "alert:error",
              erro
            );
          })
        .then(() => {
          this.processando(false);
        });
    },
    showDialogRetifAnalise() {
      this.showRetificarDecAnalise = true;
    },
    closeDialogRetifAnalise() {
      this.limparDadosDecAnalise();
      this.showRetificarDecAnalise = false;
    },
    limparDadosDecAnalise() {
      this.decAnalise.motivoRetificacao = '';
    },
    saveRetencaoIndevida() {
      this.processando(true);
      DeclaracaoSubstituicao.retencaoIndevida(this.currentUser.usuario.idUsuario, this.motivoRetencaoIndevida, this.notaSelecionada).then(
        data => {
          console.log(data);
          this.$root.$emit(
            "alert:success",
            "Retenção indevida realizada com sucesso!"
          );
          this.pesquisar();
          this.showDialogAceiteTomador = false;
        },
        error => {
          console.log(error);
          this.$root.$emit(
            "alert:error",
            error.response.data
          );
        }
      ).then(() => {
        this.processando(false);
      });
    },
    saveMotivoRetifcacao() {
      this.decAnalise.idDeclaracao = this.declaracaoSelecionada.id;
      this.decAnalise.idContribuinte = this.currentUser.contribuinte.idContribuinte;

      DeclaracaoRetificacaoService.retificarDeclaracaoAnalise(this.decAnalise).then(
        data => {
          console.log(data);
          this.$root.$emit(
            "alert:success",
            "Solicitação de Retificação enviada com sucesso!"
          );
          this.closeDialogRetifAnalise();
        },
        error => {
          console.log(error);
          this.$root.$emit(
            "alert:error",
            error.response.data
          );
        }
      );
    },
    saveMotivoRecDaps() {
      this.processando(true);
      this.dapsRecusa.id = this.dapsSelecionada.daps.id;
      DapsService.salvarRecusaDaps(this.dapsRecusa).then(
        data => {
          console.log(data);
          this.$root.$emit(
            "alert:success",
            "Motivo de Recusa salvo com sucesso!"
          );
          this.closeDialogRecDaps();
          this.pesquisar();
        },
        error => {
          let errorMessage = "Houve um erro ao salvar a Obra!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
      this.processando(false);
    },
    limparDadosRecDaps() {
      this.dapsRecusa.motivoRecusa = '';
    },
    exportarExcel(id) {
      var idDeclaracao = id;
      this.exportarDeclaracaoTipo('xls', idDeclaracao);
    },
    exportarDeclaracaoTipo(tipo, idDeclaracao) {
      this.processando(true);
      ReportService.imprimir("DeclaracaoMensalServicosXls", [
        {
          param: "ID",
          string: idDeclaracao,
        },
        {
          param: "TIPO",
          string: "S",
        },
      ], tipo)
        .then(
          () => { },
          error => {
            this.$root.$emit("alert:warn", "Erro ao Imprimir!");
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    visualizarDanfse(idNota) {
      this.processando(true);

      NotaFiscalService.downloadDanfseHtml(idNota)
        .then(response => {
            const html = response.data;
            ReportService.openHtmlFromBytes(html);
        }).catch(error => {
            this.$root.$emit("alert:warn", "Erro ao efetuar o download da DANFSE!");
            console.error('Erro ao efetuar o download da DANFSE:', error);
        }).then(() => {
            this.processando(false);
        });
    },
    impressaoNota(idNotaNotaDeclaracao) {
      this.processando(true);
      let ret = idNotaNotaDeclaracao.split(";");
      let id = ret[1];
      if (ret[0] === "N") {
        let nomeRel = this.observacaoClienteNfse
          ? "NotaFiscalEletronicaObs"
          : "NotaFiscalEletronica";
        ReportService.imprimir(nomeRel, [
          {
            param: "where",
            string: " and nota_fiscal.id = '" + id + "' ",
          },
        ])
          .then(
            (data) => {
              console.log(data);
            },
            (error) => {
              this.$root.$emit("alert:warn", "Erro ao exibir a visualização!");
              console.log(error);
            }
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        ReportService.imprimir("NotaFiscalAuxiliar", [
          {
            param: "where",
            string: " and nota.id = '" + id + "' ",
          },
        ])
          .then(
            () => { },
            (error) => {
              this.$root.$emit("alert:warn", "Erro ao Imprimir!");
              console.log(error);
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
    },
    impressaoDeclaracao(id) {
      console.log(id);
      this.processando(true);
      ReportService.imprimir("DeclaracaoMensalServicos", [
        {
          param: "ID",
          string: id,
        },
        {
          param: "TIPO",
          string: "S",
        },
      ])
        .then(
          (data) => {
            console.log(data);
          },
          (error) => {
            this.$root.$emit(
              "alert:warn",
              "Erro ao imprimir Detalhamento Declaração!"
            );
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    impressaoProtocolo(id) {
      this.processando(true);
      ReportService.imprimir("nfs_protocolo_declaracao", [
        {
          param: "ID",
          string: id,
        }
      ])
        .then(
          (data) => {
            console.log(data);
          },
          (error) => {
            this.$root.$emit(
              "alert:warn",
              "Erro ao imprimir Detalhamento Declaração!"
            );
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    compararDatasSemHora(data1, data2) {
      // Remove hora, minuto, segundo e milissegundo
      const d1 = new Date(data1.getFullYear(), data1.getMonth(), data1.getDate());
      const d2 = new Date(data2.getFullYear(), data2.getMonth(), data2.getDate());

      if (d1 > d2) return 1;    // data1 é depois de data2
      if (d1 < d2) return -1;   // data1 é antes de data2
      return 0;                 // datas são iguais (ignorando hora)
    },
    impressaoBoletos(id, pago) {
      console.log(pago);
      this.processando(true);
      this.idDeclaracaoSelecionada = id;
      DeclaracaoService.competenciaEmFiscalizacao(this.idDeclaracaoSelecionada)
        .then((responseFisc) => {
          console.log(responseFisc);
          if (responseFisc.data === 'S') {
            this.$root.$emit(
              "alert:warn",
              "Não sera possível a Imppressão do Boleto, Contribuinte em processo de Fiscalização para o período da declaração!"
            );
            this.processando(false);
            return;
          }
          DeclaracaoSubstituicao.findBoletos(id)
            .then((response) => {
              this.listBoletos = response.data;

              this.boletos = this.listBoletos.find(boleto => {
                return boleto;
              });

              this.vencimentoMaximo = new Date(this.boletos.vencimentoAnterior);
              //por problemas com a data vinda do backend tranformando em Date js vai ser incluido 1 dia pois o seDate esta retirando 1 dia ao transformar a data
              this.vencimentoMaximo.setDate(this.vencimentoMaximo.getDate() + 1);
              if (this.travaDam > 0) {
                this.vencimentoMaximo.setDate(this.vencimentoMaximo.getDate() + this.travaDam);
              }
            })
            .then(() => {
              this.showImpressaoBoletos = true;

              this.displayBoletos = true;
              this.processando(false);
            });
        })
    },
    hideBoletos() {
      this.displayBoletos = false;
    },
    async imprimirBoletoTaxa(taxa) {
      this.processando(true);
      await GpiService.imprimirTaxa(taxa.idCliente, taxa.ano, taxa.numero).then(
        (data) => {
          console.log(data);
        },
        (error) => {
          this.$root.$emit("alert:warn", "Erro ao exibir a visualização!");
          console.log(error);
        }
      ).then(() => {
        this.displayBoletos = false;
        this.processando(false);
      });
    },
    cancelarTaxa() {
      if (!this.motivoCancelamentoTaxa) {
        this.$root.$emit("alert:warn", "Informe o motivo da cancelamento!")
        return;
      }

      this.processando(true);
      DeclaracaoService.cancelarTaxa(
        this.currentUser.usuario.idUsuario, 
        this.currentUser.contribuinte.idContribuinte,
        this.taxaSelecionada.idCliente,
        this.taxaSelecionada.ano,
        this.taxaSelecionada.numero,
        this.motivoCancelamentoTaxa
      ).then(
        (data) => {
          this.$root.$emit("alert:success", "Taxa cancelada com sucesso!");
          console.log(data);
        },
        (error) => {
          this.$root.$emit("alert:warn", "Não foi possível cancelar a Taxa!");
          console.log(error);
        }
      ).then(() => {
        this.displayCancelarTaxa = false;
        this.carregarTaxas();
        this.processando(false);
      });
    },
    exibirCancelarTaxa(taxa) {
      this.taxaSelecionada = taxa;
      this.motivoCancelamentoTaxa = '';
      this.displayCancelarTaxa = true;
    },
    async carregarTaxas() {
      DeclaracaoService.findTaxas(
        this.currentUser.contribuinte.idContribuinte,
        this.filtroAno.key, this.filtroMes.key, ''
      ).then(
        (response) => {
          console.log(response);
          this.listTaxas = response.data;
        },
        (error) => {
          console.log(error);
          this.$root.$emit("alert:warn", error.response.data);
        })
    },
    carregarVencimentoBoleto(id, dataVencimento, tipoEmissao) {
      this.tipoEmissaoBoleto = tipoEmissao;
      this.showEscolhaPix = false;
      let d = dataVencimento.split("-");
      this.idDamAgrupamento = id;
      this.dataVencimento = new Date(d[0], d[1] - 1, d[2]);
      this.bloqueiaDataVencDam();
      this.displayVencBoleto = true;
    },
    hideVencBoleto() {
      this.displayVencBoleto = false;
      this.idDecLancamentoSelecionado = null;
      this.idDamAgrupamento = null;
    },
    consultarPagamentoPix(idDamAgrupamento) {
      if (idDamAgrupamento) {
        this.processando(true);
        DeclaracaoSubstituicao.consultarPagamentoPix(
          this.idDeclaracaoSelecionada,
          idDamAgrupamento
        )
          .then(
            (response) => {
              console.log(response);
              this.pesquisar();
              this.hideBoletos();
              this.showPix = false;
              this.$root.$emit("alert:info", response.data);
            },
            (error) => {
              console.log(error);
              this.$root.$emit("alert:warn", error.response.data);
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
    },
    imprimirBoleto() {
      if (!this.dataVencimento) {
        this.$root.$emit("alert:warn", "Data de Vencimento Obrigatória!");
        return;
      }
      this.processando(true);
      var novaData = new Date();
      if (this.travaDam >= 0 && this.compararDatasSemHora(novaData, this.vencimentoMaximo) === 1 && !this.admin) {
        this.$root.$emit("alert:warn", "A Data de Vencimento não pode ser posterior ao vencimento máximo!");
        this.processando(false);
      }else if (this.travaDam >= 0 && this.compararDatasSemHora(this.dataVencimento, this.vencimentoMaximo) === 1 && !this.admin) {
        this.$root.$emit("alert:warn", "A Data de Vencimento não pode ser posterior ao vencimento máximo!");
        this.processando(false);
      } else {
        if (novaData > this.dataVencimento) {
          this.dataVencimento = novaData;
        }
        DeclaracaoSubstituicao.atualizarVencimento(
          this.idDamAgrupamento,
          this.idDeclaracaoSelecionada,
          this.dataVencimento
        )
          .then(
            (response) => {
              console.log(response);
              let idGerado = response.data;
              ReportService.imprimir("trb_dam_a5", [
                {
                  param: "RP_ID_CLIENTE",
                  string: this.currentUser.usuario.idCliente,
                },
                {
                  param: "P_CONTROLE_PARCELA",
                  string:
                    " and cp.id_situacao in('1','4','6')  and  cp.id in ('" +
                    idGerado +
                    "')",
                },
              ]).then(
                (data) => {
                  console.log(data);
                },
                (error) => {
                  this.$root.$emit(
                    "alert:warn",
                    "Erro ao exibir a visualização!"
                  );
                  console.log(error);
                }
              );
            },
            (error) => {
              this.$root.$emit("alert:warn", "Erro ao atualizar Vencimento!");
              console.log(error);
            }
          )
          .then(() => {
            this.hideVencBoleto();
            this.hideBoletos();
            this.processando(false);
          });
      }
    },
    bloqueiaDataVencDam() {
      if (this.travaDam === 0 && !this.admin) {
        this.disableDataVencDam = true;
      } else if (this.travaDam === -1 && !this.admin) {
        this.disableDataVencDam = true;
        this.vencimentoMaximo = new Date();
        this.dataVencimento = new Date();
      } else if (this.travaDam === -2 && !this.admin) {
        this.disableDataVencDam = false;
      } else {
        this.disableDataVencDam = false;
      }
    },
    escolhaPagamentoPix(idDamAgrupamento, dataVencimento) {
      this.idDamAgrupamento = idDamAgrupamento;
      this.dataVencimento = dataVencimento;
      this.showEscolhaPix = true;
    },
    criarPagamentoPix() {
      this.processando(true);

      //seta o vencimento como a data atual quando gera o qr code, pois não solicita data na tela
      let vencimento = new Date();

      if (this.travaDam >= 0 && this.compararDatasSemHora(vencimento, this.vencimentoMaximo) === 1 && !this.admin) {
        this.$root.$emit("alert:warn", "A Data de Vencimento não pode ser posterior ao vencimento máximo!");
        this.processando(false);
        return;
      }

      DeclaracaoSubstituicao.criarPagamentoPix(
        this.idDamAgrupamento,
        this.idDeclaracaoSelecionada
      )
        .then(
          (response) => {
            console.log(response);
            this.pixGerado = response.data;
            this.optionsPix.data = this.pixGerado.qrCode;
            this.showPix = true;
          },
          (error) => {
            this.pixGerado = null;
            this.$root.$emit("alert:warn", error);
            console.log(error);
          }
        )
        .then(() => {
          this.showEscolhaPix = false;
          this.processando(false);
        });
    },
    carregarAvulsos(id) {
      this.processando(true);
      DeclaracaoSubstituicao.findAllDecAvulsa(id)
        .then((responseNota) => {
          this.listAvulsos = responseNota.data;
        })
        .then(() => {
          this.processando(false);
          this.displayAvulsos = true;
        });
    },
    hideAvulsos() {
      this.displayAvulsos = false;
    },
    impressaoComprovante(id) {
      console.log(id);
      ReportService.imprimir("ComprovanteRetencaoImposto", [
        {
          param: "ID_DECLARACAO",
          string: id,
        },
      ]).then(
        (data) => {
          console.log(data);
        },
        (error) => {
          this.$root.$emit(
            "alert:warn",
            "Erro ao imprimir Detalhamento Declaração!"
          );
          console.log(error);
        }
      );
    },
    isNotaFiscal(idNotaNotaDeclaracao) {
      let ret = idNotaNotaDeclaracao.split(";");
      return ret[0] === "N";
    },
    downloadXml(nfseId) {
      this.processando(true);
      let ret = nfseId.split(";");
      let id = ret[1];
      ReportService.downloadXml(id)
        .then(
          (data) => {
            console.log(data);
          },
          (error) => {
            this.$root.$emit("alert:warn", "Erro ao efetuar o download!");
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    imprimirBoletoPix() {
      if (!this.dataVencimento) {
        this.$root.$emit("alert:warn", "Data de Vencimento Obrigatória!");
        return;
      }
      this.processando(true);
      console.log(this.tipoDam);
      var novaData = new Date();
      if (this.travaDam >= 0 && this.compararDatasSemHora(novaData, this.vencimentoMaximo) === 1 && !this.admin) {
        this.$root.$emit("alert:warn", "A Data de Vencimento não pode ser posterior ao vencimento máximo!");
        this.processando(false);
      }else if (this.travaDam >= 0 && this.compararDatasSemHora(this.dataVencimento, this.vencimentoMaximo) === 1 && !this.admin) {
        this.$root.$emit("alert:warn", "A Data de Vencimento não pode ser posterior ao vencimento máximo!");
        this.processando(false);
      } else {
        if (novaData > this.dataVencimento) {
          this.dataVencimento = novaData;
        }
        DeclaracaoSubstituicao.atualizarVencimento(
          this.idDamAgrupamento,
          this.idDeclaracaoSelecionada,
          this.dataVencimento
        )
          .then(
            (response) => {
              console.log(response);
              let idGerado = response.data;
              DeclaracaoSubstituicao.criarPagamentoPixCp(
                idGerado,
                this.idDeclaracaoSelecionada
              )
                .then(
                  (response) => {
                    console.log(response);
                    this.pixGerado = response.data;
                    ReportService.imprimir("trb_dam_a5_pix", [
                      {
                        param: "RP_ID_CLIENTE",
                        string: this.currentUser.usuario.idCliente,
                      },
                      {
                        param: "QR_CODE",
                        string: this.pixGerado.qrCode,
                      },
                      {
                        param: "P_CONTROLE_PARCELA",
                        string:
                          " and cp.id_situacao in('1','4','6')  and  cp.id in ('" +
                          idGerado +
                          "')",
                      },
                    ]).then(
                      (data) => {
                        console.log(data);
                      },
                      (error) => {
                        this.$root.$emit(
                          "alert:warn",
                          "Erro ao exibir a visualização!"
                        );
                        console.log(error);
                      }
                    );
                  },
                  (error) => {
                    this.pixGerado = null;
                    this.$root.$emit("alert:warn", error);
                    console.log(error);
                  }
                )
                .then(() => {
                  this.showEscolhaPix = false;
                  this.processando(false);
                });
            },
            (error) => {
              this.$root.$emit("alert:warn", "Erro ao atualizar Vencimento!");
              console.log(error);
            }
          )
          .then(() => {
            this.hideVencBoleto();
            this.hideBoletos();
            this.processando(false);
          });
      }
    },
    formatted_string(pad, user_str, pad_pos) {
      if (typeof user_str === "undefined") return pad;
      if (pad_pos == "l") {
        return (pad + user_str).slice(-pad.length);
      } else {
        return (user_str + pad).substring(0, pad.length);
      }
    },
    isExibirDataPagamento() {
      return this.currentUser.contribuinte.idBolFechamentoRegimeCaixa == 'S'
    },
    async exportCSVDt1() {
      await DeclaracaoSubstituicao.getConsultaRelDecXlsComp(this.filtroAno.key, this.filtroMes.key, null, null).then(
        (response) => {
          response.data;
          this.sqlRelatorio = response.data;
        },
        (error) => {
          console.log(error);
        }
      );
      this.imprimirExcel();
    },
    imprimirExcel() {
      this.imprimirConsultaTipo('xls');
    },
    imprimirConsultaTipo(tipo) {
      this.processando(true);
      ReportService.imprimir("ConsultaDamXls", [
        {
          param: "P_CONSULTA",
          string: this.sqlRelatorio
        }
      ], tipo)
        .then(
          () => { },
          error => {
            this.$root.$emit("alert:warn", "Erro ao Imprimir!");
            console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });
    },
    async imprimirNotificacao(idDeclaracao) {
      this.processando(true);

      try {
        let idCalculoParcelado = null;
        await DeclaracaoSubstituicao.obterCalculoDeclaracao(idDeclaracao).then(
          (response) => {
            idCalculoParcelado = response.data;
          },
          (error) => {
            this.$root.$emit("alert:warn", error.response.data);
            return;
          }
        );
        await GpiService.imprimirNotificacao(this.currentUser.usuario.idCliente, idCalculoParcelado);
      } catch (error) {
        if (error.response && error.response.status === 400) {
          const e = await error.response.data.text();
          try {
            const outer = JSON.parse(e);
            const inner = JSON.parse(outer.message);
            this.$root.$emit("alert:warn", inner.message || "Erro desconhecido");

          } catch (e) {
            this.$root.$emit("alert:warn", e);
          }
        } else {
          this.$root.$emit("alert:warn", "Erro ao exibir a visualização!");
        }
      }
      this.processando(false);
    },
    consultarNotasADN() {
      let ano = this.filtroAno.key;
      let mes = this.filtroMes.key;
      this.processando(true);
      this.$root.$emit("declaracao:consultaNotasNacionais", this.currentUser.usuario.idCliente, this.currentUser.contribuinte.idContribuinte, ano, mes, this.competencia);
    }
  },
  computed: {
    isBloqueado() {
      return this.currentUser && this.currentUser.idBolBloquearSistema && this.currentUser.idBolBloquearSistema === 'S';
    },
    isAnaliseRetificacao: {
      get() {
        return this.currentUser.configuracao.idBolDecRetifAnalise === 'S';
      }
    },
    isPossuiTaxas: {
      get() {
        return this.listTaxas && this.listTaxas.length > 0;
      }
    },
    isPossuiTaxasDebito: {
      get() {
        return this.isPossuiTaxas && this.listTaxas.some(taxa => taxa.idBolDebito === 'S');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.white-line {
  color: white;
}

/deep/ .green-row {
  background-color: #28a745 !important;
}

/deep/ .red-row {
  background-color: #fd7272 !important;
}

textarea {
  width: 100%;
  border-radius: 12Px;
}

.subtitle {
  margin-left: 55px;
  font-size: 14px;
  opacity: 0.8;
}

.custom-input {
  width: 80%;
  text-align: center;
  padding: 12px;
  border-radius: 12px;
  font-size: 16px;
  background-color: #f4f6f9;
  border: 1px solid #dcdcdc;
}
</style>